module.exports = __webpack_public_path__ + "static/media/banner-facebook-icon.a37b6a52.svg";